import React from 'react';
import Link from 'next/link';
import { useTranslation } from 'react-i18next';
import { useBridgeState } from '@digitaz/bridge-sdk-client';
import * as S from './SettingsSection.styles';
import { ChangeLang } from '@/components/ChangeLang/ChangeLang';
import { IconBox } from '@/components/UI/IconBox/IconBox.styles';
import { ROUTES } from '@/constants/routes';
import { Drawer } from '@/components/Drawer/Drawer';
import { AngleBackIcon } from '@/components/UI/Icons/Icons';
import { useToggleOpenState } from '@/hooks/useToggleOpenState';
import { Button } from '@/components/UI/Button/Button';
import { Popup } from '@/components/UI/Popup/Popup';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const SettingsSection = () => {
  const { t } = useTranslation();
  const [isDrawerOpen, toggleDrawer] = useToggleOpenState();
  const [isPopupOpen, togglePopup] = useToggleOpenState();
  const { isWebView } = useBridgeState();

  function remove() {
    togglePopup();
    toggleDrawer();
  }

  function logout() {
    console.log('logout');
  }

  return (
    <>
      {!isWebView && (
        <S.Items $isFirst>
          <S.Item $isLast>
            <IconBox $filename="language.svg" $width={19} $height={19} />
            <ChangeLang />
          </S.Item>
        </S.Items>
      )}

      <S.Items>
        <S.Item href={ROUTES.faq} as={Link} $isLast>
          {t('common.help')}
        </S.Item>
      </S.Items>

      <S.Items>
        <S.Item href={ROUTES.terms} as={Link}>
          {t('common.terms_of_use')}
        </S.Item>
        <S.Item href={ROUTES.rules} as={Link}>
          {t('common.placement_rules')}
        </S.Item>
        <S.Item href={ROUTES.privacy} as={Link}>
          {t('common.privacy_policy')}
        </S.Item>
        <S.Item href={ROUTES.advertising} as={Link}>
          {t('common.advertising_on_site')}
        </S.Item>

        <S.Items>
          <S.Item $isLast onClick={toggleDrawer}>
            {t('pages.cabinet.remove_account')}
          </S.Item>
        </S.Items>

        <S.Items onClick={logout}>
          <S.Item $isLogOut>{t('common.exit')}</S.Item>
        </S.Items>
      </S.Items>

      <Drawer
        isOpen={isDrawerOpen}
        close={toggleDrawer}
        title={t('pages.cabinet.removing_account')}
        hasBottomMargin={false}
        left={{
          icon: <AngleBackIcon />,
          onClick: toggleDrawer,
        }}
      >
        <S.Content>
          <Typography.Header $variant="3">
            {t('pages.cabinet.removing_account_note_1')}
          </Typography.Header>
          <S.List>
            <S.ListItem $variant="1" as="li">
              {t('pages.cabinet.removing_account_note_2')}
            </S.ListItem>
            <S.ListItem $variant="1" as="li">
              {t('pages.cabinet.removing_account_note_3')}
            </S.ListItem>
            <S.ListItem $variant="1" as="li">
              {t('pages.cabinet.removing_account_note_4')}
            </S.ListItem>
          </S.List>

          <Button appearance="red" isFullWidth onClick={togglePopup}>
            {t('pages.cabinet.remove_account')}
          </Button>
        </S.Content>

        <Popup
          isOpen={isPopupOpen}
          close={togglePopup}
          title={t('pages.cabinet.remove_account_question_mark')}
          description={t('pages.cabinet.cant_restore_it_after_removing')}
          actions={{
            left: {
              text: t('common.decline'),
              onClick: togglePopup,
            },
            right: {
              isRed: true,
              text: t('common.remove'),
              onClick: remove,
            },
          }}
        />
      </Drawer>
    </>
  );
};
